"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeVerify = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var core_1 = require("@moralisweb3/core");
var MoralisAuth_1 = require("../MoralisAuth");
var evmVerifyChallenge_1 = require("../resolvers/evmVerifyChallenge");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var makeEvmVerify = function (core, _a) {
    var network = _a.network, options = __rest(_a, ["network"]);
    return api_utils_1.EndpointResolver.create(core, MoralisAuth_1.BASE_URL, evmVerifyChallenge_1.completeChallenge).fetch({
        message: options.message,
        signature: options.signature,
    });
};
var makeVerify = function (core) { return function (options) {
    switch (options.network) {
        case 'evm':
            return makeEvmVerify(core, options);
        default:
            return (0, core_1.assertUnreachable)(options.network);
    }
}; };
exports.makeVerify = makeVerify;
//# sourceMappingURL=verify.js.map